import { connect } from 'react-redux';
import { map } from '@beef/utils';
import { selectCrudeMappingContext, selectCrudeMappingState } from "../store";
import { SilentMappingException } from "../exceptions/SilentMappingException";
var retrievePath = function retrievePath(object, path) {
  if (!path.length) return object;
  return retrievePath(object[path[0]], path.slice(1));
};
var parseCrudeMapping = function parseCrudeMapping(value, mapping, localMapping) {
  try {
    // Быстрый выход, если первый символ не $, то значит поле без маппинга
    if (typeof value !== 'string' || value[0] !== '$') return value;
    // $. - маппинг корневой модели
    if (value[1] === '.' || value[1] === undefined) return mapping(value.substring(2).split('.'));
    // $$. - маппинг локального алиаса
    if (value[1] === '$' && (value[2] === '.' || value[2] === undefined)) return localMapping(value.substring(3).split('.'));
    // $$$. - маппинг текущего элемента (пустого alias'а), фактически это эквивалентно $$..
    if (value[2] === '$' && (value[3] === '.' || value[3] === undefined)) return localMapping(value.substring(3).split('.'));
    return value;
  } catch (err) {
    throw new SilentMappingException("\u041E\u0448\u0438\u0431\u043A\u0430 \u043C\u0430\u043F\u043F\u0438\u043D\u0433\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0435 \u0447\u0442\u0435\u043D\u0438\u044F ".concat(value, ":\n\n").concat(err.message), {
      stack: err.stack
    });
  }
};
export var withCrudeMapping = function withCrudeMapping() {
  return connect(function (state, ownProps) {
    return map(ownProps, function (value) {
      return parseCrudeMapping(value, function (path) {
        return retrievePath(selectCrudeMappingState(state), path);
      }, function (path) {
        return retrievePath(selectCrudeMappingContext(state), path);
      });
    });
  }, {});
};